import React from 'react';
import {Button, ButtonGroup} from '@material-ui/core';
import {Guid} from '../../ext/lib/types';
import UserContext from '../common/UserContext';

type Props = {adKey: Guid};

function handleInvoice(e: React.MouseEvent<HTMLButtonElement>) {
  const key = e.currentTarget.dataset.key ?? 'missing-key';
  window.location.href = `/invoice/${encodeURIComponent(key)}`;
}

export default function AdminAdActions({adKey}: Props): JSX.Element {
  const {apiToken} = React.useContext(UserContext);
  const userToken = apiToken || 'unknown-token';

  async function handleDelete(e: React.MouseEvent<HTMLButtonElement>) {
    if (window.confirm('Are you sure?')) {
      try {
        const key = e.currentTarget.dataset.key ?? 'missing-key';
        await fetch(`/api/v1/requests/delete/${key}`, {
          method: 'DELETE',
          headers: {
            Authorization: userToken
          }
        }).then(async apiResponse => {
          if (apiResponse.status === 200) {
            // TODO: refactor so that ad list contains state that can be updated without reloading page.
            window.location.reload();
          } else {
            const r = await apiResponse.json();
            console.log('Error deleting ad: %o', r.error);
            alert('Unable to delete ad. Try again or contact support.');
          }
        }).then(() => {
          window.location.reload();
        }).catch(() => {
          alert('Unable to delete ad. Try again or contact support.');
        });
      } catch (err) {
        alert('Unable to delete ad. Try again or contact support.');
      }
    }
  }

  async function handleEdit(e: React.MouseEvent<HTMLButtonElement>) {
    const key = e.currentTarget.dataset.key ?? 'missing-key';
    window.location.href = `/edit/${encodeURIComponent(key)}`;
  }


  return <ButtonGroup variant="outlined" color="primary">
    <Button onClick={handleEdit} data-key={adKey}>Edit</Button>
    <Button onClick={handleDelete} data-key={adKey}>Delete</Button>
    <Button onClick={handleInvoice} data-key={adKey}>Invoice</Button>
  </ButtonGroup>;
}
